import React, { useEffect, useState } from 'react';
import ipAddressImage from '../images/ip-address.png';
import NotePad from './notePad.js';

const IpData = () => {
    const [ip, setIp] = useState(null);
    const [location, setLocation] = useState('Fetching');
    const [ipType, setIpType] = useState('Fetching');
    const [tooltipContent, setTooltipContent] = useState("Copy");
    const [dataReceipt, setDataReceipt] = useState(false);
    const [notePadVisible, setNotePadVisible] = useState(false);
    const [noteContent, setNoteContent] = useState('');

    const formattedIp = String(ip).replace(/\./g, ' . ');
    const url = 'https://ipdataapi.azurewebsites.net/api/HttpTrigger1?code=y95qxV28_z9dHtQQVy5MGN4T0qR8NnxVD0R6qHOj8X9vAzFuWWKEYA==';

    useEffect(() => {
        // Load notepad state from localStorage
        const savedNote = localStorage.getItem('troubleshootingNote');
        const visible = localStorage.getItem('notePadVisible');
        setNoteContent(savedNote || '');
        setNotePadVisible(visible === 'true');
    }, []);

    useEffect(() => {
        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                setIp(data.ip);
                setLocation(data.location);
                setIpType(data.ipType);
                setDataReceipt(true);
                console.log(data);
            });
    }, []);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(ip).then(() => {
            setTooltipContent("Copied!");
            setTimeout(() => setTooltipContent("Copy"), 2000);
        });
    };

    return (
        <div className="ipContainer">
            {ip && <div className="text-subheading"><p>Your IP Address</p></div>}

            <div className="ipDisplayContainer">
                <img id="ipSymbol" width="25px" height="25px" src={ipAddressImage} alt="IP Address" />

                <h1 className="text-heading">
                    {ip ? formattedIp : <div className="spinner"></div>}
                </h1>

                <span
                    onClick={copyToClipboard}
                    className="material-symbols-outlined site-icons"
                    data-tooltip={tooltipContent}
                >
                    content_copy
                </span>
            </div>

            {dataReceipt && (
                <div className="ipDetail location">
                    <table>
                        <tbody>
                            <tr><td><b>City</b></td><td>{location.city}</td></tr>
                            <tr><td><b>State</b></td><td>{location.region}</td></tr>
                            <tr><td><b>Country</b></td><td>{location.country}</td></tr>
                        </tbody>
                    </table>
                </div>
            )}

            <br /><br />

            <div className="notePadContainer">
                {notePadVisible !== null && (
                    <NotePad
                        defaultVisible={notePadVisible}
                        defaultContent={noteContent}
                    />
                )}
            </div>
        </div>
    );
};

export default IpData;
